"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotFaceAngry = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotFaceAngry = _ref => {
  let {
    spotColor = "#C34648",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "face_red_angry_svg__a",
    d: "M0 0h37v37H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "face_red_angry_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#face_red_angry_svg__a"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M1.024 18.5c0 9.65 7.85 17.5 17.5 17.5s17.5-7.85 17.5-17.5S28.174 1 18.524 1s-17.5 7.85-17.5 17.5Z",
    mask: "url(#face_red_angry_svg__b)",
    opacity: 0.5
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M18.5 0C28.7 0 37 8.299 37 18.5S28.7 37 18.5 37C8.298 37 0 28.701 0 18.5S8.298 0 18.5 0Zm0 1.517C9.135 1.517 1.517 9.136 1.517 18.5S9.135 35.483 18.5 35.483 35.483 27.864 35.483 18.5 27.865 1.517 18.5 1.517Zm.135 20.691c3.47 0 6.682 1.574 8.81 4.319a.81.81 0 0 1-.143 1.139.808.808 0 0 1-1.14-.143 9.467 9.467 0 0 0-7.527-3.69 9.5 9.5 0 0 0-7.301 3.411.812.812 0 1 1-1.245-1.042 11.117 11.117 0 0 1 8.546-3.994Zm6.419-9.555c.798 0 1.648.579 1.648 1.65 0 1.068-.85 1.644-1.648 1.644-.421 0-.818-.145-1.117-.412-.342-.303-.53-.74-.53-1.233 0-1.07.848-1.649 1.647-1.649Zm0 1.27c-.141 0-.377.05-.377.38 0 .326.236.375.377.375.141 0 .378-.049.378-.376 0-.128-.035-.224-.103-.285a.42.42 0 0 0-.275-.093Zm-12.658-1.27c.799 0 1.648.579 1.648 1.65 0 1.068-.85 1.644-1.648 1.644-.421 0-.817-.145-1.117-.412-.342-.303-.53-.74-.53-1.233 0-1.07.848-1.649 1.647-1.649Zm0 1.27c-.141 0-.377.05-.377.38 0 .326.236.375.377.375.141 0 .378-.049.378-.376 0-.128-.034-.224-.103-.285a.42.42 0 0 0-.275-.093Zm15.08-7.098a.86.86 0 0 1 .715 1.55l-.095.05-5.73 2.647-.1.039a.86.86 0 0 1-.716-1.55l.095-.05 5.73-2.647.1-.04Zm-16.681 0 .1.039 5.73 2.646a.86.86 0 0 1-.621 1.6l-.1-.038-5.73-2.646a.86.86 0 0 1 .62-1.601Z",
    mask: "url(#face_red_angry_svg__b)"
  })));
};
exports.SpotFaceAngry = SpotFaceAngry;
SpotFaceAngry.displayName = "SpotFaceAngry";